<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        flat
        v-on="on"
      >
        <v-icon left>
          image
        </v-icon>
        Gallery
      </v-btn>
    </template>
    <v-card>
      <v-toolbar
        flat
        dark
        color="primary"
      >
        <v-btn
          icon
          dark
          @click="onCancelUpdate"
        >
          <v-icon>close</v-icon>
        </v-btn>
        <v-toolbar-title>Blog Gallery</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn
            dark
            flat
            @click="onSaveUpdate"
          >
            Save
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-container
        grid-list-md
        fluid
      >
        <v-layout v-if="items.length === 0">
          <v-flex class="text-xs-center">
            No data available
          </v-flex>
        </v-layout>
        <v-layout
          v-else
          wrap
        >
          <v-flex
            v-for="(item, index) in items"
            :key="index"
            lg4
          >
            <v-card>
              <v-img
                :src="item.object_url"
                :lazy-src="item.object_url"
                aspect-ratio="1.7778"
              />
              <v-card-actions>
                <v-btn
                  v-if="itemObject.id !== item.id"
                  flat
                  block
                  :disabled="selected_image === item"
                  @click="selected_image = item"
                >
                  {{ selected_image === item ? 'This image is selected' : 'Select this image' }}
                </v-btn>
                <v-btn
                  v-else
                  flat
                  block
                  disabled
                >
                  This image is currently being used
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    itemObject: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      dialog: false,
      selected_image: null
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'blogGallery/isLoading',
      items: 'blogGallery/galleries'
    })
  },
  watch: {
    // call again the method if the route changes
    '$route': 'fetchData'
  },
  created () {
    // fetch the data when the view is created and the data is
    // already being observed
    if (this.items.length === 0) {
      this.fetchData()
    }
  },
  methods: {
    ...mapActions({
      fetchData: 'blogGallery/getGalleries',
      updatePostItem: 'blogPosts/updatePostItem'
    }),
    onSaveUpdate () {
      this.updatePostItem({
        key: 'image',
        value: this.selected_image
      })
      this.dialog = false
    },
    onCancelUpdate () {
      this.selected_image = null
      this.dialog = false
    }
  }
}
</script>
